import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
} from "@syncfusion/ej2-react-grids";

export default function NearToExpiryGrid({ data = [] }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "Near_Expiry_GridID_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="Near_Expiry_GridID"
              dataSource={data}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"350px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  width="100"
                  textAlign="Center"
                  isPrimaryKey={true}
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="PopulatedDate"
                  headerText="Populated Date"
                  width="200"
                  textAlign="Center"
                  type="date"
                  format="dd/MM/yyyy"
                />
                <ColumnDirective
                  field="LocationCode"
                  headerText="Location"
                  width="170"
                  textAlign="Center"
                />
                <ColumnDirective
                  field="ArticleCode"
                  headerText="Article Code"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="EanPlu"
                  headerText="EAN/PLU"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ActualShelfDays"
                  headerText="Shelf Days"
                  width="200"
                  textAlign="Center"
                />
                <ColumnDirective
                  field="OneSixthShelfDays"
                  headerText="1/6 Shelf Days"
                  width="220"
                  textAlign="Center"
                />
                <ColumnDirective
                  field="StockOnHand"
                  headerText="Stock on Hand"
                  width="200"
                  textAlign="Right"
                  format="N2"
                />
                <ColumnDirective
                  field="ManufacturingDate"
                  headerText="Mfg Date"
                  width="200"
                  textAlign="Center"
                  type="date"
                  format="dd/MM/yyyy"
                />
                <ColumnDirective
                  field="ExpiryType"
                  headerText="Expiry Type"
                  width="200"
                  textAlign="Center"
                />
                <ColumnDirective
                  field="ExpiryQty"
                  headerText="Expiry Qty"
                  width="200"
                  textAlign="Right"
                  format="N2"
                />
                <ColumnDirective
                  field="ExpiryDate"
                  headerText="Expiry Date"
                  width="190"
                  textAlign="Center"
                  type="date"
                  format="dd/MM/yyyy"
                />
                <ColumnDirective
                  field="MRP"
                  headerText="MRP"
                  width="150"
                  textAlign="Right"
                //   format="C2"
                />
                <ColumnDirective
                  field="CSP"
                  headerText="CSP"
                  width="170"
                  textAlign="Right"
                //   format="C2"
                />
                <ColumnDirective
                  field="IsActive"
                  displayAsCheckBox={true}
                  headerText="Active"
                  width="100"
                  textAlign="Center"
                />
              </ColumnsDirective>
              <Inject
                services={[
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
      </div>
    </>
  );
}